module.exports = __webpack_public_path__ + "img/under-construction.0cc4e491.gif";